import React, { useState } from 'react';
import { optimizedImageUrl, optimizedSrcSet } from '../utils/image';
type OptimizedImageProps = {
  src: string;
  alt: string;
  width: number;
  height: number;
  widths: number[];
  sizes: string;
  className?: string;
  priority?: boolean;
};
export function OptimizedImage({
  src,
  alt,
  width,
  height,
  widths,
  sizes,
  className,
  priority = false
}: OptimizedImageProps) {
  const [failed, setFailed] = useState(false);
  const fallbackWidth = widths[Math.min(1, widths.length - 1)];
  return <img src={failed ? src : optimizedImageUrl(src, fallbackWidth)} srcSet={failed ? undefined : optimizedSrcSet(src, widths)} sizes={failed ? undefined : sizes} alt={alt} width={width} height={height} className={className} loading={priority ? 'eager' : 'lazy'} decoding={priority ? 'sync' : 'async'} onError={() => setFailed(true)} {...priority ? {
    fetchpriority: 'high'
  } : {}} data-id="element-11" data-mp="1ttczqqovnkig" />;
}